export default {
      id: "logo_agency-usage",
      viewBox: "0 0 229 40",
      url: __webpack_public_path__ + "sprite.svg#logo_agency-usage",
      toString: function () {
        return this.url;
      }
    }